import { Component } from '@angular/core';
@Component({
  selector: 'itl-loading-indicator',
  template: `<ion-spinner name="lines"></ion-spinner>`,
  styleUrls: ['./loading-indicator.component.scss'],
})
export class LoadingIndicatorComponent {}
